import { BreakOption } from '@types';
import { OgpApiService } from './ogp-api-service';
import {
  BulkShiftCreationCSVUploadPayload,
  BulkShiftCreationCSVUploadResponse,
  GetCalendarShiftPlanningListItemsParams,
  GetCalendarShiftPlanningListItemsResponse,
  GetTableShiftPlanningListItemsParams,
  GetTableShiftPlanningListItemsResponse,
} from './shift-service.types';

export class ShiftService {
  constructor(private readonly ogpApiService: OgpApiService) {}

  public getCalendarShiftPlanningListItems = async (
    params: GetCalendarShiftPlanningListItemsParams
  ) => {
    const response = await this.ogpApiService.get<GetCalendarShiftPlanningListItemsResponse>({
      path: 'shifts/planning/calendar',
      params,
    });
    return response;
  };

  public getTableShiftPlanningListItems = async (params: GetTableShiftPlanningListItemsParams) => {
    const response = await this.ogpApiService.get<GetTableShiftPlanningListItemsResponse>({
      path: 'shifts/planning/table',
      params,
    });
    return response;
  };

  public getBreakOptions = async () => {
    const response = await this.ogpApiService.get<{ breakOptions: BreakOption[] }>({
      path: `shifts/get-break-options`,
    });

    return response;
  };

  public archiveShift = async (shiftId: string) => {
    return await this.ogpApiService.update({
      path: `shifts/${shiftId}/archive`,
    });
  };

  public bulkShiftCreationCSVUpload = async (file: BulkShiftCreationCSVUploadPayload) => {
    const formData = new FormData();
    formData.append('file', file.file);
    return await this.ogpApiService.create<BulkShiftCreationCSVUploadResponse>({
      path: 'shifts/process-csv',
      body: formData,
    });
  };
}
